module.exports = __webpack_public_path__ + "static/media/NJM_Insurance_Group_logo.c8fa7ddc.png";